module.exports = new __parcel__URL__("add.6dea82c4.png").toString();